module.exports = __webpack_public_path__ + "img/toggle-up.7a6c91a6.svg";